import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeAreaFormModal, openAreaViewModal } from "../../store/reducers/fortalezas/fortalezas.reducer";
import { useEffect, useState } from "react";
import {
  updateAreaDesarrolloThunk,
  getAreasDesarrolloThunk,
  getAreaDesarrolloByIdThunk,
} from "../../store/reducers/fortalezas/fortalezas.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from "react-toastify";

const AreaFormModal = () => {
  const dispatch = useDispatch();
  const {
    areaFormModalOpen,
    selectedArea,
    areaFormLoading,
    areaFormError,
    areasPage,
    areasSearch,
  } = useSelector((state) => state.fortalezas);

  const [formData, setFormData] = useState({
    area: "",
    descripcion: "",
  });

  useEffect(() => {
    if (selectedArea) {
      setFormData({
        area: selectedArea.area || "",
        descripcion: selectedArea.descripcion || "",
      });
    }
  }, [selectedArea, areaFormModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      area: formData.area,
      descripcion: formData.descripcion,
    };

    const result = await dispatch(
      updateAreaDesarrolloThunk({
        id: selectedArea.id,
        payload,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getAreasDesarrolloThunk({ page: areasPage, search: areasSearch }));
      toast.success("Área actualizada exitosamente");
      await dispatch(getAreaDesarrolloByIdThunk(selectedArea.id));
      dispatch(openAreaViewModal());
    }
  };

  return (
    <Modal
      open={areaFormModalOpen}
      onClose={() => dispatch(closeAreaFormModal())}
      title="Editar área de desarrollo"
      size="lg"
    >
      {areaFormLoading ? (
        <Loader center type="dots" text="Actualizando área..." />
      ) : (
        <form onSubmit={handleSubmit}>
          {areaFormError && <Alert message={areaFormError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Área <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="area"
              value={formData.area}
              onChange={handleChange}
              placeholder="Nombre del área de desarrollo"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">Descripción</label>
            <textarea
              className="form-control"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción del área"
              rows="3"
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeAreaFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AreaFormModal;
